import { Dict } from '/imports/types';

export const Subscriptions: Dict<() => boolean> = {};

export const registerSubscription = (name: string, sub: () => boolean) => {
  Subscriptions[name] = sub;
};